<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
                <div align="center">
                 <img class="navbar-brand-full" src="img/logos/fsj.jpg" height="50" alt="Packapp Logo">
                </div>
              <b-card-body>
                <b-form @submit.prevent="onSubmit">
                  <p class="text-muted">Ingrese sus credenciales</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text"  v-model="usuario" class="form-control" placeholder="Usuario" autocomplete="" required />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="contrasena" class="form-control" placeholder="Contraseña" autocomplete="current-password" required />
                  </b-input-group>
                  <b-row>
                    <b-col cols="12" class="text-center">
                      <b-button type="submit" variant="primary" class="px-4">Ingresar <i class="fa fa-lg fa-arrow-circle-right"></i></b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>



export default {
  name: 'Login',
  data () {
    return {
      usuario: '',
      contrasena: ''
    }
  },
  created() {

    this.$axios.interceptors.request.use((config) => {

     //console.log("Aqui 1");
      return config;
    }, (error) => {

     //console.log("Aqui 2");
      return Promise.reject(error);
    });

    this.$axios.interceptors.response.use((response) => {

      return response;
    }, (error) => {

     //console.log("Aqui 3");
      return Promise.reject(error);
    });
  },
    methods: {
    onSubmit() {
      this.$store.dispatch('login', {username: this.usuario, password: this.contrasena} )
      .then(() => this.$router.push('/'))
      .catch(err => {
        console.log(err);
        this.$swal.fire(
            "Imposible iniciar sesión con las credenciales proporcionadas",
            "",
            "error"
          );
      })

      }
    },
   mounted(){

    },
  computed: {


  }
}

</script>
